/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiStrymeAcceptEventPost } from '../fn/stryme/api-stryme-accept-event-post';
import { ApiStrymeAcceptEventPost$Params } from '../fn/stryme/api-stryme-accept-event-post';
import { apiStrymeProcessEventPost } from '../fn/stryme/api-stryme-process-event-post';
import { ApiStrymeProcessEventPost$Params } from '../fn/stryme/api-stryme-process-event-post';

@Injectable({ providedIn: 'root' })
export class StrymeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiStrymeAcceptEventPost()` */
  static readonly ApiStrymeAcceptEventPostPath = '/api/Stryme/accept_event';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStrymeAcceptEventPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStrymeAcceptEventPost$Response(params?: ApiStrymeAcceptEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiStrymeAcceptEventPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStrymeAcceptEventPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStrymeAcceptEventPost(params?: ApiStrymeAcceptEventPost$Params, context?: HttpContext): Observable<void> {
    return this.apiStrymeAcceptEventPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStrymeProcessEventPost()` */
  static readonly ApiStrymeProcessEventPostPath = '/api/Stryme/process_event';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStrymeProcessEventPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStrymeProcessEventPost$Response(params?: ApiStrymeProcessEventPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiStrymeProcessEventPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiStrymeProcessEventPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiStrymeProcessEventPost(params?: ApiStrymeProcessEventPost$Params, context?: HttpContext): Observable<void> {
    return this.apiStrymeProcessEventPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
